import styled from "styled-components";
import colors from "styles/colors";

export const FooterContainer = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  align-self: stretch;
  flex-wrap: wrap;
`;

export const Content = styled.div`
  display: flex;
  height: 80px;
  padding: 24px;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 12px;
  flex: 1 0 0;
  flex-wrap: wrap;
  background: ${colors.punch[600]};
`;

export const Div = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 0 0;
`;

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 10px;
  flex: 1 0 0;
`;

export const Point = styled.p`
  color: ${colors.brightGray[50]};
  text-align: center;
  font-family: "Source Sans Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 166%;
  letter-spacing: 0.4px;
`;

export const Copyright = styled.div`
  flex: 1 0 0;
  color: ${colors.brightGray[50]};
  font-family: "Source Sans Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 166%;
  letter-spacing: 0.4px;
`